import React, { useEffect } from 'react';
import './pvivienda.css';
import { pvivienda } from '../../json/pvivienda';


const Pvivienda = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Programa de Fortalecimiento a la Calidad y Espacios de la Vivienda para el Ejercicio Fiscal 2022 (Programa Finalizado)</h3>
          <hr className='hr-gob' />
        </div>
      </div>
      Que a fin de contribuir a la igualdad de oportunidades para que todos los hidalguenses incrementen su calidad de vida, mediante el mejoramiento para una vivienda digna, el Gobierno del Estado de Hidalgo implementó el Programa Fortalecimiento a la Calidad y Espacios de la Vivienda, diseñado para apoyar a los hogares de menores ingresos económicos disminuyendo el alto y muy alto rezago social con acciones de mejora en la calidad de la vivienda, servicios básicos en la vivienda y obras de infraestructura urbana y rescate de espacios públicos, que permitan un desarrollo humano e igualitario en municipios prioritarios que presenten carencias sociales.
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              
              <div style={{ textAlign: 'left' }}>
                <h6 className='description' style={{ marginTop: '20px' }}>
                  
                </h6><br />
                <h5 style={{ fontWeight: 'bold' }}>Objetivo</h5>
                <p>
                Contribuir al mejoramiento en la calidad y espacios de la vivienda y servicios básicos de la vivienda en el Estado de Hidalgo, mediante obras de infraestructura en beneficio de las familias hidalguenses.
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Beneficiarios</h5>
                <p>
                La población del Estado de Hidalgo que habita en localidades y municipios con carencias por calidad y espacios de la vivienda, por servicios básicos en la vivienda e infraestructura urbana o rural.
                </p>
                <p>
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href="/Transparencia/pdfs/ROPs/ROP's_Vivienda_2022.pdf"
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Reglas de Operación</a></strong></h5>
                <p>
                </p>
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/Padrones/2023/Padron_Vivienda.pdf"
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Padrón de Beneficiarios</a></strong></h5>
                <p>
                </p>
                

                    <a
                // href='https://www.google.com'
                // target='_blank'
                // rel="noopener noreferrer"
                // style={{ fontWeight: 'bold' }}
                // className='span'
                >
                
                </a>.
                </p>
              </div>
            </div>
            
          </div>
        </div>
      </div>    
    </div>
  );
};

export default Pvivienda;